// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-spot-area[data-v-49a86cad]{top:12px;width:2px;height:9px;position:absolute;left:5px;border-left:2px dotted #dbdee3;opacity:1}.accordion-enter-active[data-v-49a86cad],.accordion-leave-active[data-v-49a86cad]{transition:height 1s ease}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
